import * as Sentry from '@sentry/react';
import ErrorBoundary from 'Components/ErrorBoundary/ErrorBoundary';
import NotFoundPage from 'Components/NotFoundPage/NotFoundPage';
import RegisterInvitedPartner from 'FeatureModules/Auth/Pages/RegisterInvitedPartner';
import RegisterInvitedUser from 'FeatureModules/Auth/Pages/RegisterInvitedUser';
import { BlockNavigationContextProvider } from 'Contexts/BlockNavigationContext';
import CustomProviders from 'Contexts/CustomProviders';
import { VersionProvider } from 'Contexts/VersionProvider';
import AuthApolloProvider from 'graphql/auth/AuthApolloProvider';
import SecureApolloProvider from 'graphql/secure/SecureApolloProvider';
import React, { FC } from 'react';
import { Route, RouterProvider, Routes, createBrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import AuthenticatedRoutes from './AuthenticatedRoutes';
import Login from 'FeatureModules/Auth/Pages/Login';
import PasswordForgot from 'FeatureModules/Auth/Pages/PasswordForgot';
import Register from 'FeatureModules/Auth/Pages/Register';
import TokenizedLogin from 'FeatureModules/Auth/Pages/TokenizedLogin';

/** These providers needs to live inside and access the browser route context  */
const INNER_ROUTER_PROVIDERS = [
  { provider: QueryParamProvider, props: { adapter: ReactRouter6Adapter } },
  VersionProvider,
  BlockNavigationContextProvider,
];

/**
 * The main router of the application it requires currently object structure and is only needed to use route blocking and other features
 * It returns a data router, later this should also be used as react element as soon as the react-router team releases the new version
 */
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  {
    id: 'root',
    path: '/*',
    errorElement: <ErrorBoundary />,
    element: (
      <CustomProviders providers={INNER_ROUTER_PROVIDERS}>
        <Routes>
          <Route element={<AuthApolloProvider />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-partner" element={<RegisterInvitedPartner />} />
            <Route path="/invitation" element={<RegisterInvitedUser />} />
            <Route path="/password-forgot" element={<PasswordForgot />} />
            <Route path="/verify-user" element={<TokenizedLogin />} />
          </Route>

          <Route element={<SecureApolloProvider />}>
            <Route path="/*" element={<AuthenticatedRoutes />} />
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </CustomProviders>
    ),
  },
]);

const Router: FC = () => <RouterProvider router={router} />;

export default Router;
